import i18n from "i18n";
import { convertDateToUTC } from "helpers/utils";
import DefectStatusIcon from "components/Elements/DefectStatusIcon";
import {
	addDays,
	endOfDay,
	endOfMonth,
	endOfWeek,
	startOfDay,
	startOfMonth,
	startOfWeek,
	subDays,
	subMonths,
	subWeeks,
	getWeek
} from "date-fns";
export const redService = ["T", "X", "N", "S"];
export const greenService = ["C", "P", "I", "O"];

export const serviceStatus = {
	T: "Stopped",
	X: "Cancelled",
	N: "Incomplete",
	S: "Scheduled",
	C: "Complete",
	P: "Complete (By Paper)",
	I: "In Progress",
	O: "Checked Out",
	H: "Checked Out",
};

export const changeStatusReason = (customCaptions) => [
	{ id: "X", name: "Cancel", showIn: "S" },
	{
		id: "C",
		name: `Complete (${customCaptions?.taskPlural ?? "Tasks"} Skipped)`,
		showIn: "T",
	},
	{ id: "N", name: "Incomplete", showIn: "T" },
	{ id: "P", name: "Completed by Paper", showIn: "S" },
];

export const mappeedStatusReason = {
	S: "X",
	name: "Cancel",
};

export const statusOfServices = (status, TasksSkipped, customCaptions) => {
	switch (status) {
		case "T":
			return TasksSkipped === false
				? i18n.t("label.stopped")
				: i18n.t("label.stoppedTasksSkipped", { tasks: customCaptions?.taskPlural ?? "Tasks" });
		case "X":
			return i18n.t("label.cancelled");
		case "N":
			return i18n.t("action.incomplete");
		case "S":
			return i18n.t("label.scheduled");
		case "C":
			return TasksSkipped === false
				? i18n.t("action.complete")
				: i18n.t("label.completeTasksSkipped", { tasks: customCaptions?.taskPlural ?? "Tasks" });
		case "P":
			return i18n.t("label.completeByPaper");
		case "I":
			return i18n.t("label.inProgress");
		case "O":
			return i18n.t("label.checkedOut");
		case "H":
			return i18n.t("label.checkedOut");

		default:
			break;
	}
};

export const serviceTableHeader = (
	allowIndividualAssetModels,
	customCaptions,
	showServiceClientName,
	t
) => {
	return allowIndividualAssetModels === true
		? [
				{ id: 1, name: customCaptions.serviceWorkOrder },
				...(showServiceClientName ? [{ id: 16, name: t("label.clientName") }] : []),
				{
					id: 17,
					name: (
						<DefectStatusIcon
							label={customCaptions?.defect || t("entity.defect")}
							tooltip={customCaptions?.defect || t("entity.defect")}
						/>
					),
				},
				{ id: 8, name: customCaptions.model },
				{ id: 9, name: customCaptions.asset },
				{ id: 11, name: customCaptions.interval },
				{ id: 12, name: customCaptions.role },
				{ id: 2, name: t("label.status") },
				{ id: 3, name: t("label.percentCompleted"), width: "200px" },
				{ id: 5, name: t("label.percentTimeUnderOver") },
				{ id: 6, name: t("label.timeMinsUnderOver") },
				{ id: 7, name: t("label.minsRemaining") },

				{ id: 13, name: t("label.scheduledDateTime") },
				{ id: 14, name: t("label.currentEntity", { entity: customCaptions.user }) },
				{ id: 15, name: t("label.entityStarted", { entity: customCaptions.service }) },
		  ]
		: [
				{ id: 1, name: t("label.workOrder") },
				...(showServiceClientName ? [{ id: 16, name: t("label.clientName") }] : []),
				{
					id: 17,
					name: (
						<DefectStatusIcon
							label={customCaptions?.defect || t("entity.defect")}
							tooltip={customCaptions?.defect || t("entity.defect")}
						/>
					),
				},
				{ id: 8, name: customCaptions.model },
				{ id: 11, name: customCaptions.interval },
				{ id: 12, name: customCaptions.role },
				{ id: 2, name: t("label.status") },
				{ id: 3, name: t("label.percentCompleted"), width: "200px" },
				{ id: 5, name: t("label.percentTimeUnderOver") },
				{ id: 6, name: t("label.timeMinsUnderOver") },
				{ id: 7, name: t("label.minsRemaining") },
				{ id: 13, name: t("label.scheduledDateTime") },
				{ id: 14, name: t("label.currentEntity", { entity: customCaptions.user }) },
				{ id: 15, name: t("label.entityStarted", { entity: customCaptions.service }) },
		  ];
};
export const serviceTableColumns = (
	allowIndividualAssetModels,
	showServiceClientName
) => {
	return allowIndividualAssetModels === true
		? [
				"workOrder",
				...(showServiceClientName ? ["clientName"] : []),
				"hasDefects",
				"modelName",
				"siteAssetName",
				"interval",
				"role",
				"status",
				"percentageComplete",
				"percentageOverTime",
				"minutesOverTime",
				"estimatedMinutes",
				"scheduledDate",
				"checkoutUser",
				"checkoutDate",
		  ]
		: [
				"workOrder",
				...(showServiceClientName ? ["clientName"] : []),
				"hasDefects",
				"modelName",
				"interval",
				"role",
				"status",
				"percentageComplete",
				"percentageOverTime",
				"minutesOverTime",
				"estimatedMinutes",
				"scheduledDate",
				"checkoutUser",
				"checkoutDate",
		  ];
};

export const defaultTimeframe = {
	id: "",
	name: "Show All",
	fromDate: "",
	toDate: "",
};

export const showAllInDropDown = {
	id: 2,
	name: "Not Complete",
	statusType: "O",
};

export const filterByDateOptions = (
	todayDate,
	customCaptions,
	weekStartDay = 1
) => {
	// Calculate week numbers
	const thisWeekNumber = getWeek(todayDate, { weekStartsOn: weekStartDay ?? 1 });
	const lastWeekNumber = getWeek(subWeeks(todayDate, 1), { weekStartsOn: weekStartDay ?? 1 });
	
	return [
	{ id: "", name: "Show All", fromDate: "", toDate: "" },
	{
		id: 1,
		name: "Today",
		fromDate: convertDateToUTC(startOfDay(todayDate)),
		toDate: convertDateToUTC(endOfDay(todayDate)),
	},
	{
		id: 12,
		name: "Yesterday",
		fromDate: convertDateToUTC(startOfDay(subDays(todayDate, 1))),
		toDate: convertDateToUTC(endOfDay(subDays(todayDate, 1))),
	},
	{
		id: 13,
		name: "Tomorrow",
		fromDate: convertDateToUTC(startOfDay(addDays(todayDate, 1))),
		toDate: convertDateToUTC(endOfDay(addDays(todayDate, 1))),
	},
	{
		id: 8,
		name: `This Week (${thisWeekNumber})`,
		fromDate: convertDateToUTC(
			startOfWeek(todayDate, { weekStartsOn: weekStartDay ?? 1 })
		),
		toDate: convertDateToUTC(
			endOfWeek(todayDate, { weekStartsOn: weekStartDay ?? 1 })
		),
	},
	{
		id: 2,
		name: `Last Week (${lastWeekNumber})`,
		fromDate: convertDateToUTC(
			startOfWeek(subWeeks(todayDate, 1), { weekStartsOn: weekStartDay ?? 1 }) // first day of the previous week
		),
		toDate: convertDateToUTC(
			endOfWeek(subWeeks(todayDate, 1), { weekStartsOn: weekStartDay ?? 1 }) // last day of the previous week
		),
	},
	{
		id: 3,
		name: "Last Fortnight",
		fromDate: convertDateToUTC(subDays(todayDate, 14)),
		toDate: convertDateToUTC(endOfDay(todayDate)),
	},
	{
		id: 4,
		name: "Last Month",
		fromDate: convertDateToUTC(subDays(todayDate, 30)), // First day of last month
		toDate: convertDateToUTC(endOfDay(todayDate)),
	},
	{
		id: 5,
		name: "Last Year",
		fromDate: convertDateToUTC(subDays(todayDate, 365)),
		toDate: convertDateToUTC(endOfDay(todayDate)),
	},
	{
		id: 6,
		name: "Future " + customCaptions?.servicePlural,
		fromDate: convertDateToUTC(addDays(todayDate, 1)),
		toDate: "",
	},
	{
		id: 7,
		name: "Custom Range...",
	},
]};

export const serviceMonitorQuestionHeader = (customCaptions, modelType) =>
	modelType === "F"
		? [
				{
					id: 1,
					name: customCaptions.stage,
				},
				{
					id: 2,
					name: customCaptions.zone,
				},
				{
					id: 3,
					name: customCaptions.task,
				},
				{
					id: 4,
					name: customCaptions.question,
				},
				{
					id: 5,
					name: customCaptions.arrangement || i18n.t("entity.arrangement"),
				},
				{
					id: 6,
					name: customCaptions.asset,
				},
		  ]
		: [
				{
					id: 1,
					name: customCaptions.stage,
				},
				{
					id: 2,
					name: customCaptions.zone,
				},
				{
					id: 3,
					name: customCaptions.task,
				},
				{
					id: 4,
					name: customCaptions.question,
				},
				{
					id: 5,
					name: customCaptions.arrangement || i18n.t("entity.arrangement"),
				},
		  ];

export const serviceMonitorQuestionCols = (modelType) =>
	modelType === "F"
		? [
				{ id: 1, name: "stageName" },
				{ id: 2, name: "zoneName" },
				{ id: 3, name: "taskName" },
				{ id: 4, name: "question" },
				{ id: 5, name: "arrangementName" },
				{ id: 6, name: "siteAssetName" },
		  ]
		: [
				{ id: 1, name: "stageName" },
				{ id: 2, name: "zoneName" },
				{ id: 3, name: "taskName" },
				{ id: 4, name: "question" },
				{ id: 5, name: "arrangementName" },
		  ];

export const serviceGarphId = "serviceganttchartid";
